import { Button, DatePicker, Skeleton } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import dayjs from "dayjs";
import API from 'API';

export default function CourseTermInfo({ course, selectedTerm }) {
    const [courseTermInfo, setCourseTermInfo] = useState({});
    const [gettingCourseTermInfo, setGettingCourseTermInfo] = useState(true);
    const [savingInfo, setSavingInfo] = useState(false);

    useEffect(() => {
        if (!selectedTerm) return;
        async function getData() {
            setGettingCourseTermInfo(true);
            try {
                const response = await API.post("/course-term-info/", {
                    term_id: selectedTerm.id,
                    course_id: course.id,
                    get: true
                });
                response.data.final_exam_time = response.data.final_exam_time && dayjs(response.data.final_exam_time);
                setCourseTermInfo(response.data);
                setGettingCourseTermInfo(false);
            } catch (e) {
                console.log(e);
            } finally {

            }
        }
        getData();
    }, [selectedTerm, course.id])

    const saveInfo = useCallback((value) => {
        const nValue = {...value};
        nValue.final_exam_time = nValue.final_exam_time?.format();
        setSavingInfo(true);
        API.post("/course-term-info/", {
            term_id: selectedTerm.id,
            course_id: course.id,
            ...nValue
        })
        .then(res => {

        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            setSavingInfo(false);
        })
    },[selectedTerm, course.id])

    return gettingCourseTermInfo ? <Skeleton active /> : <div>
        <b>Ngày thi cuối kỳ:</b> <DatePicker showTime value={courseTermInfo.final_exam_time} onChange={
            v => setCourseTermInfo(value => ({...value, final_exam_time: v}))
        }/>
        <Button loading={savingInfo} disabled={savingInfo}
            onClick={() => saveInfo(courseTermInfo)}
            type='primary' style={{ margin: 3}}
        >
            Lưu
        </Button>
    </div>
}
